import { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';

import cn from 'classnames';
import Input from '../../../../Basic/Inputs/Base';

const ProviderEditInput = ({
  name = '',
  wb_kvant = '',
  width = '100%',
  onChange = (_) => _,
  maxLength = 500,
  styleText = {},
}) => {
  const [openInput, setInput] = useState(false);
  const [inputName, setInputName] = useState(name);

  const save = (v) => {
    setInput(false);
    setInputName(v);
    onChange(v);
  };
  const ref = useRef(null);

  useEffect(() => {
    setInputName(name);
  }, [name]);

  return (
    <div className={styles.block_inline}>
      <div className={styles.block}>
        {openInput ? (
          <>
            <Input
              value={inputName}
              width={width}
              onClickEnter={(v) => save(v)}
              onBlur={(v) => save(v)}
              autoFocus={true}
              ref={ref}
              maxLength={maxLength}
              className={styles.input_name}
            />
            {wb_kvant}
          </>
        ) : (
          <div
            onClick={() => setInput(true)}
            className={cn(styles.name, (inputName || '').length === 0 && styles.name_empty)}
            style={styleText}
          >
            {inputName}
            {wb_kvant}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProviderEditInput;
